import { PageRoute, SignDisclosureContainer } from 'shared/components';
import { DocumentIntroContainer, DisclosureReview } from 'components';

const SigningRoutes = () => (
  <>
    <PageRoute exact path="/applications/:uuid/signing/intro" hasLeaveSurvey>
      <DocumentIntroContainer />
    </PageRoute>
    <PageRoute exact path="/applications/:uuid/signing/sign" hasLeaveSurvey>
      <SignDisclosureContainer />
    </PageRoute>
    <PageRoute exact path="/applications/:uuid/signing/disclosures" hasLeaveSurvey>
      <DisclosureReview />
    </PageRoute>
  </>
);

export default SigningRoutes;
